import React, { Component } from 'react';
import Input from '../../../forms/Input';
import SelectField from '../../../../components/forms/SelectField';
import { RT_TYPE_CONTRACT } from '../../../../constants/admin/settings';
import TinyMCERichTextEditor from '../TinyMCERichTextEditor';
import ImageUpload from '../../../forms/ImageUpload';
import { CONTRACT_TYPES, CONTRACT_TYPE_OPTIONS } from '../../../../constants/settings';

class TemplateInputs extends Component {
    _onSaveEditor = content => {
        this.props.onInput(content, 'data');
    };
    _changeType = type => {
        if (type !== CONTRACT_TYPES.CLEARANCE) {
            this.props.onInput({}, 'clearing');
        }
        this.props.onInput(type, 'type');
    };

    componentDidUpdate(prevProps) {
        if (!prevProps.data.type && !this.props.metadata.canAccessPerformanceContracts) {
            this.props.onInput(CONTRACT_TYPES.CLEARANCE, 'type');
        }
    }

    render() {
        return (
            <React.Fragment>
                <div className="ckp-admin-forms-body">
                    <div className="ckp-admin-grid-row u-margin-bottom-3">
                        <div className="ckp-admin-grid-column">
                            <ImageUpload
                                className="is-big"
                                label="Add logo"
                                value={this.props.data.logo}
                                onChange={this.props.onInput}
                                name="logo"
                            />
                        </div>
                        <div className="ckp-admin-grid-column">
                            <SelectField
                                disabled={this.props.withContext}
                                items={this.props.contextOptions}
                                label="Organization *"
                                onChange={this.props.onInput}
                                name="organizationId"
                                className="is-small-padding"
                                value={this.props.data.organizationId}
                            />
                            <SelectField
                                disabled={!!this.props.data.id || !this.props.metadata.canAccessPerformanceContracts}
                                items={CONTRACT_TYPE_OPTIONS}
                                label="Type *"
                                onChange={this._changeType}
                                name="type"
                                className="is-small-padding"
                                value={this.props.data.type}
                            />
                            <Input
                                errorMessage={this.props.errors.name}
                                label="Template Name *"
                                name="name"
                                className="is-without-padding"
                                onChange={this.props.onInput}
                                value={this.props.data.name}
                            />
                        </div>
                    </div>
                    <div className="ckp-admin-grid-row">
                        <TinyMCERichTextEditor
                            type={RT_TYPE_CONTRACT}
                            value={this.props.data.data}
                            onChange={this._onSaveEditor}
                        />
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default TemplateInputs;



// WEBPACK FOOTER //
// ./src/components/admin/forms/contracts/TemplateInputs.js